import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, pure, withState, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import createFocusDecorator from 'final-form-focus';

import * as actions from 'actions';
import { holdMutators } from 'utils';

import Form from './Form';
import { handlers } from './shared';

const propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  initialValues: PropTypes.shape({
    token: PropTypes.string,
    contact: PropTypes.objectOf(PropTypes.any),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const focusOnError = createFocusDecorator();

function EditContact({ id, initialValues, loading, onSubmit }) {
  return (
    <FinalForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      id={id}
      mutators={{ ...holdMutators }}
      decorators={[focusOnError]}
      subscription={{ submitting: true, pristine: true }}
      loading={loading}
      component={Form}
    />
  );
}

EditContact.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
  return {
    fetchContact: bindActionCreators(actions.fetchContact, dispatch),
    onSubmitAction: bindActionCreators(actions.updateContact, dispatch),
  };
}

const enhance = compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps,
  ),
  withState('loading', 'setLoading', false),
  withHandlers({
    setDefaultInitialValues: handlers.setDefaultInitialValues,
  }),
  withState('initialValues', 'setInitialValues', ({ setDefaultInitialValues }) => setDefaultInitialValues()),
  withHandlers({
    mergeInitialValues: handlers.mergeInitialValues,
    onSubmit: handlers.onSubmit,
  }),
  lifecycle({
    async componentDidMount() {
      const { fetchContact, match, mergeInitialValues, id, setLoading } = this.props;
      const { token } = match.params;
      setLoading(true);
      await fetchContact(token, id).then(mergeInitialValues);
      setLoading(false);
    },
  }),
  pure,
);

export default enhance(EditContact);
